<template>
  <footer class="bg-dark text-white py-4 footer-section">
    <div class="container text-center">
      <p>&copy; 2025 E-Mart. All Rights Reserved.</p>
      <ul class="list-inline">
        <router-link rel="stylesheet" to="privacy-policy"><li class="list-inline-item"><a href="#" class="text-white">Privacy Policy</a></li></router-link>
        <!-- <li class="list-inline-item"><a href="#" class="text-white">Terms of Service</a></li>
        <li class="list-inline-item"><a href="#" class="text-white">Contact Us</a></li> -->
      </ul>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterSection'
};
</script>

<style >
/* .footer-section {
  margin-top: auto; 
} */

</style>
